import axios from "axios";
import Swal from "sweetalert2";
import api from "./api_refresh_token";
import { isObject } from "formik";
import { baseURL } from "./api_base";

axios.defaults.headers.common["Access-Control-Allow-Origin"] =
  "GET, POST, DELETE, PUT"; // definindo o que meu axios pode fazer

//Token
const getToken = () => {
  let token = localStorage.getItem("token");
  return token;
};

export const getPerfil = () =>
  api
    .get(`${baseURL}/perfis`, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      if (error.response && error.response.status === 422) {
        const errors = error.response.data.errors;
        Swal.fire({
          icon: "error",
          title: isObject(errors) ? Object.values(errors)[0][0] : errors,
        });
      } else if (error.response && error.response.status === 500) {
        Swal.fire({
          icon: "error",
          title: "Erro interno do servidor",
          text: "Ocorreu um erro interno no servidor. Por favor, tente novamente mais tarde.",
        });
      } else {
        console.log(error);
      }
    })
    .then(function (response) {
      return response;
    });
